import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RestResponse } from '../../models/restResponse.mode';
import { Pdv } from './dto/pdv';
import { ClosePdvDto } from './dto/closePdvDto';

@Injectable({
  providedIn: 'root'
})
export class PdvService {
  private readonly baseUrl = `${environment.base_url}/pdv`;

  constructor(private http: HttpClient) {}

  create(openingValue: number): Observable<RestResponse<Pdv>> {
    var params = {openingValue: openingValue}
    return this.http.post<RestResponse<Pdv>>(`${this.baseUrl}/save`, params);
  }

  close(id: number, dto: ClosePdvDto): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/close/${id}`, dto);
  }

}
